import { globalEntitlements } from '../utils/globalEntitlements';

/** @typedef {import('../types').ProductLandingConfig} ProductLandingConfig */

/** @type {ProductLandingConfig} */
export const SHOPIFY_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.shopify.buyBox.bulletPoint1' },
          { title: 'productPage.shopify.buyBox.bulletPoint2' },
          { title: 'productPage.shopify.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.shopify.buyBox.productName',
        veloCta: {
          displayVeloCta: true,
          promptMessageId: 'productPage.shopify.buyBox.veloCta.prompt',
          topic: 'shopify',
        },
        interactService: {
          ctaType: 'externalCheckout',
          service: 'shopify',
          openInNewTab: true,
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/women-managing-store.png',
      alt: 'productPage.shopify.heroPicture.altText',
    },
    headline: 'productPage.shopify.page.headline',
    partnerLogo: {
      src: '/s2/vector/shopify-logo.svg',
      alt: '',
    },
    partnerReviewBlanks: [
      {
        text: 'productPage.shopify.page.reviewText1',
      },
      {
        src: '/illustration/trustpilot-4.5-star.svg',
        showOnMobile: true,
        alt: '',
      },
      {
        src: '/illustration/trustpilot-logo.svg',
        alt: '',
      },
    ],
    subheader: 'productPage.shopify.page.subheader',
  },
  benefit: {
    title: 'productPage.shopify.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/languagerounded.svg',
        title: 'productPage.shopify.valueProp.propTitle1',
        description: 'productPage.shopify.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/dashboardrounded.svg',
        title: 'productPage.shopify.valueProp.propTitle2',
        description: 'productPage.shopify.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/webrounded.svg',
        title: 'productPage.shopify.valueProp.propTitle3',
        description: 'productPage.shopify.valueProp.shortCopy3',
      },
    ],
  },
  howItWorks: {
    title: 'productPage.shopify.howItWorks.title',
    items: [
      {
        title: 'productPage.shopify.howItWorks.step1',
        description: 'productPage.shopify.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.shopify.howItWorks.step2',
        description: 'productPage.shopify.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.shopify.howItWorks.step3',
        description: 'productPage.shopify.howItWorks.shortDescription3',
      },
      {
        title: 'productPage.shopify.howItWorks.step4',
        description: 'productPage.shopify.howItWorks.shortDescription4',
      },
    ],
    image: '/s2/raster/woman-using-laptop-home-office.png',
    alt: 'productPage.shopify.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  highlight: {
    icon: '/s2/material-icons/rocketlaunchrounded.svg',
    title: 'productPage.shopify.highlight.title',
    subheader: 'productPage.shopify.highlight.subheader',
    image: '/s2/raster/store-plants-laptop.png',
    alt: 'productPage.shopify.highlight.altText',
  },
  whatsIncluded: {
    title: 'productPage.shopify.whatsIncluded.title',
    items: [
      {
        title: 'productPage.shopify.whatsIncluded.item1',
        description: 'productPage.shopify.whatsIncluded.item1ShortDescription',
      },
      {
        title: 'productPage.shopify.whatsIncluded.item2',
        description: 'productPage.shopify.whatsIncluded.item2ShortDescription',
      },
      {
        title: 'productPage.shopify.whatsIncluded.item3',
        description: 'productPage.shopify.whatsIncluded.item3ShortDescription',
      },
    ],
    image: '/s2/raster/woman-online-store.png',
    alt: 'productPage.shopify.whatsIncluded.altText',
    hasDivider: true,
    hasNumber: false,
    hasMobileImage: false,
  },
  faqs: {
    title: 'productPage.shopify.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.shopify.frequentlyAskedQuestions.faq1',
        answer: 'productPage.shopify.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.shopify.frequentlyAskedQuestions.faq2',
        answer: 'productPage.shopify.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.shopify.frequentlyAskedQuestions.faq3',
        answer: 'productPage.shopify.frequentlyAskedQuestions.faqAnswer3',
      },
      {
        question: 'productPage.shopify.frequentlyAskedQuestions.faq4',
        answer: 'productPage.shopify.frequentlyAskedQuestions.faqAnswer4',
      },
    ],
  },
  footnotes: {
    divider: true,
    items: [
      {
        text: 'productPage.shopify.footnotes.1.text',
      },
      {
        text: 'productPage.shopify.footnotes.2.text',
      },
    ],
  },
  assistance: {
    title: 'productPage.shopify.needAssistance.title',
    getInTouch: 'productPage.shopify.needAssistance.getInTouch',
    actions: 'productPage.shopify.needAssistance.actions',
  },
  getBuyButtonConfig: globalEntitlements({
    ctaText: 'productPage.shopify.buyBox.buttonLabel',
  })
    .allowMultiplePurchases()
    .build(),
};
